import { filter, takeUntil } from 'rxjs/operators';
import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Constant } from 'src/app/constant/constant';
import { MatTableDataSource } from '@angular/material/table';
import { LeadService } from 'src/app/services/lead.service';
import icPhone from '@iconify/icons-ic/twotone-phone';
import icWhatsapp from '@iconify/icons-mdi/whatsapp';
import { LoaderService } from 'src/app/services/loader.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { DealsService } from 'src/app/services/deals.service';
import { Router, NavigationEnd } from '@angular/router';
import { DealsStageService } from 'src/app/services/deals-stage.service';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-dealskanban',
  templateUrl: './dealskanban.component.html',
  styleUrls: ['./dealskanban.component.scss']
})
export class DealskanbanComponent implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';



  DealStatusList: any;
  filterActive: boolean = false;
  spinner: boolean;
  leadList: MatTableDataSource<unknown>;
  elements: any;
  sort: any;
  paginator: any;
  pageList: any;
  pageSizeValue: number[];

  search: string;
  productList: any;
  icPhone = icPhone;
  icWhatsapp = icWhatsapp;
  leadDetailPageType: any;
  crmType: any;
  leadId: any = 0;
  statusList: any;
  defaultBackgroundcolor: any;
  configData: any;
  defaultTextcolor: any;
  kanbanviewType: any;
  crmSettingsData: any;
  storename: any;

  constructor(
    private dealsStageService: DealsStageService,
    private dealsService: DealsService,
    private ecryptService: EcryptServiceService,
    private leadService: LeadService,
    private loaderService: LoaderService,
    private cdr: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog,

  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }


  columnConnections: string[] = [];

  ngOnInit() {
    this.getDealStatus();
    const encryptedData = localStorage.getItem('configSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);
        this.configData = data;
        this.defaultBackgroundcolor = data['leftMenuBgColor'];
        this.defaultTextcolor = data['leftMenuColor']



      } catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }


    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encrypted);
        this.crmSettingsData = JSON.parse(decrypted);

        if (this.crmSettingsData != null) {

          this.storename = this.crmSettingsData.storeName;

          if (this.crmSettingsData['dealsKanbanViewType'] != undefined) {
            this.kanbanviewType = this.crmSettingsData['dealsKanbanViewType'];
          } else {
            this.kanbanviewType = 1;
          }

        }

      } catch (err) {
        console.error("Error decrypting crmSettingsData", err);
      }
    }
    // this.getAllTotalPayments();
  }
  addContact() {
    let dealId = 0;

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        let setId = data['defaultDealsSet'];




        // if (this.type == 1) {
        //   this.router.navigate([`deals/add-edit-deals/${dealId}/${setId}`])
        // } else {
        //   this.router.navigate([`deals/add-edit-deals/${dealId}/${setId}/${this.leadId}`])
        // }
        localStorage.setItem('dealsViewMode', 'kanbanView');
        this.router.navigate([`deals/add-edit-deals/${dealId}/${setId}`])
      } catch (error) {
        console.error('Error decrypting or parsing userSettingsData:', error);
      }

    }
  }



  public dropGrid(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.DealStatusList, event.previousIndex, event.currentIndex);
  }
  editProduct(leadId, setId) {
    localStorage.setItem('dealsViewMode', 'kanbanView');
    this.router.navigate([`deals/add-edit-deals/${leadId}/${setId}`])

  }
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;

  getDealStatus() {

    let url = this.router.url;
    let cleanUrl = url.split('?')[0];
    let searchTerm = localStorage.getItem(cleanUrl + "se")

    if (searchTerm == undefined) {

      searchTerm = null;

    }

    this.dealsService.getAllDealsPayment(searchTerm).subscribe(
      (res: any) => {

        this.connectedList = [];
        this.DealStatusList = res.map((column, i) => {
          const statusColor = (column.statusColor !== null && column.statusColor !== '') ? column.statusColor : this.defaultBackgroundcolor;
          const accentColor = this.getAdjustedColor(statusColor, 60);
          this.connectedList.push(column.statusId.toString());

          return {
            ...column,
            deals: [],
            tasks: [],
            page: -1, // Initialize to -1 to load page 0 first
            totalPages: 0,
            loading: false,
            backgroundColorAdjusted: this.getAdjustedColor(statusColor, 85, 0.5),
            borderColorAdjusted: '4px solid ' + accentColor,
            accentColor,
          }

        });
        this.DealStatusList.forEach((column, i) => {
          this.getDealsForColumn(column, i);
        });
      },
      error => {
        console.log("Error fetching Lead Status", error);
      }
    );
  }
  getDealsForColumn(column: any, index: number) {
    if (column.loading || (column.totalPages && column.page >= column.totalPages - 1)) return;

    column.loading = true;
    const nextPage = column.page + 1;
    let currentSearch = `stage:*${column.statusName},*`;

    let url = this.router.url;
    let cleanUrl = url.split('?')[0];
    let searchTerm = localStorage.getItem(cleanUrl + "se")
    if (searchTerm != undefined && searchTerm != null && searchTerm != '') {
      const cleanSearchTerm = searchTerm.trim().replace(/^\(+|\)+$/g, '');
      currentSearch = currentSearch + " AND " + cleanSearchTerm;
    }

    this.dealsService.getDealsBySearchMain(
      currentSearch,
      nextPage,
      this.size,
      this.sortParam,
      this.leadId
    ).subscribe(res => {
      const content = (res && Array.isArray(res['content'])) ? res['content'] : [];
      column.tasks = [...column.tasks, ...content];
      column.page = nextPage;
      column.totalPages = res && res['totalPages'] != null ? res['totalPages'] : 0;
      column.loading = false;
      this.cdr.markForCheck();
    }, () => {
      column.loading = false;
      this.cdr.markForCheck();
    });
  }
  getAdjustedColor(
    color: string,
    targetLightness: number,
    saturationAdjustmentFactor: number = 0
  ): string {
    const hex = this.parseColorToHex(color);

    const r = parseInt(hex.substring(1, 3), 16) / 255;
    const g = parseInt(hex.substring(3, 5), 16) / 255;
    const b = parseInt(hex.substring(5, 7), 16) / 255;

    const max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    let h: number = 0,
      s: number,
      l: number = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }

    const targetL = targetLightness / 100;

    const blendFactor = 0.6;
    let newL = l + (targetL - l) * blendFactor;


    newL = Math.max(0, Math.min(1, newL));
    let newS = s;
    if (newL * 100 > 90 && s > 0.1) { // Only adjust if not already desaturated

      const lightnessProximityToWhite = (newL * 100 - 90) / 10;
      newS = s * (1 - lightnessProximityToWhite * saturationAdjustmentFactor);
      newS = Math.max(0, newS);
    }


    return `hsl(${(h * 360).toFixed(0)}, ${(newS * 100).toFixed(0)}%, ${(newL * 100).toFixed(0)}%)`;
  }
  updateColor(column: any, newColor: string) {
    column.statusColor = newColor;
    this.cdr.markForCheck();
  }
  private parseColorToHex(color: string): string {

    const div = document.createElement('div');
    div.style.color = color;
    document.body.appendChild(div);


    const computed = window.getComputedStyle(div).color;
    document.body.removeChild(div);

    const rgb = computed.match(/\d+/g).map(Number);
    return '#' + rgb.map(x => {
      const hex = x.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    }).join('');
  }

  getTotalAmount(tasks: any[]): number {
    return tasks.reduce((total, task) => total + Number(task.amount || 0), 0);
  }



  sortParam: any = 'updatedDate' + "," + Constant.Dsc;

  statusMap = new Map<string, any[]>();
  connectedList: any = [];

  pageSize: any;


  onColumnScroll(event: any, column: any, index: number) {
    const container = event.target;
    const scrollThreshold = 100;


    if (container.scrollHeight - container.scrollTop - container.clientHeight <= scrollThreshold) {
      this.getDealsForColumn(column, index);
    }
  }

  //new updated functions

  public drop(event: CdkDragDrop<any[]>): void {

    if (event.previousContainer === event.container) return;

    transferArrayItem(event.previousContainer.data,
      event.container.data,
      event.previousIndex,
      event.currentIndex);

    let column = this.DealStatusList.find(x => x.statusId == event.container.id);

    let taskIndex = event.currentIndex;
    let deal = event.container.data[taskIndex];

    const isLost = column.statusName.toLowerCase().includes("lost");

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: {
        newStatus: column.statusName,
        isLost: isLost,
        description: deal.description,
        leadId: deal.leadId
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (!result?.confirmed) {
        transferArrayItem(event.container.data,
          event.previousContainer.data,
          event.currentIndex,
          event.previousIndex);
        return;
      }

      this.updateLeadStatus(column, taskIndex, result.reason, result.description, result.leadId, result.stageName);
    });
  }

  updateLeadStatus(column, taskIndex: number, reason?: string, description?: string, leadId?: any, stageName?: any) {

    let deal = column.tasks[taskIndex];

    let body: any = {
      "Stage": column.statusId,
      "entityId": deal.entityId,
      "Description": description,
      "leadId": leadId,
      "stageName": stageName
    };

    if (reason) {
      body["ReasonForLoss"] = reason;
    } else {
      body["ReasonForLoss"] = 0;
    }

    this.dealsService.editLead(body, deal.entityId).subscribe(() => {
      this.getDealStatus();
    });
  }




  getAllCrmData() {

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        if (data != null) {


          localStorage.setItem(Constant.LEAD_POPUP, data['enableInCallNotification']);
          if (data['leadDetailPageType'] != undefined) {
            this.leadDetailPageType = data['leadDetailPageType'];
          } else {
            this.leadDetailPageType = 0;
          }
          this.crmType = data['crmType'];
        } else {
          this.leadDetailPageType = 0;
        }
      }
      catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }
  }
  goToLead(element) {

    if (element.leadId != null && element.leadId != 0) {

      if (element.leadId > 0) {

        this.router.navigate([`leadDetail/${element.leadId}`])

      }



    }


  }

  goToCompany(element) {

    if (element.companyId != null && element.companyId != 0) {

      if (element.companyId > 0) {

        this.router.navigate([`companiesDetail/${element.companyId}`])

      }
    }


  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}  